import api from "api/api";

export const getNationalitiesList = async () =>
  await api.get("/settings/nationalities");
